var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "tippy",
          rawName: "v-tippy",
          value: { followCursor: true, placement: "top-center" },
          expression: "{ followCursor: true, placement: 'top-center' }",
        },
      ],
      staticClass: "reply-message",
      attrs: { content: _vm.$t("message.jumpToMessage") },
      on: { click: _vm.forwardMessage },
    },
    [
      _c("div", { staticClass: "reply-message-text" }, [
        _vm._v("\n        Replying to "),
        _c("span", [_vm._v(_vm._s(_vm.visitorName))]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "reply-message-remove",
          on: {
            click: function ($event) {
              $event.stopPropagation()
              return _vm.removeReply.apply(null, arguments)
            },
          },
        },
        [_c("div", { staticClass: "material-icons" }, [_vm._v("cancel")])]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }